module.exports = __webpack_public_path__ + "img/placeholder.dc6e8825.png";